(function () {
  const subscribeForms = document.querySelectorAll(".one-step--signup form");

  subscribeForms.forEach(function (signup) {
    const closeButton = document.querySelector('.one-step__close');
    const phone = signup.querySelector('input[type="tel"]');

    if (closeButton) {
      closeButton.addEventListener('click', function (e) {
        e.target.closest('.section--one-step-signup').classList.add('hidden');
      });
    }

    const submit = signup.querySelector(".one-step--submit");

    signup.addEventListener("submit", function (e) {
      e.preventDefault();
      
      const listId = signup.querySelector('input[name="g"]').value;
      const successMessage = signup.getAttribute("data-success-message");
      const messages = signup.querySelector(".messages");
      const subscribeUrl = "//manage.kmail-lists.com/ajax/subscriptions/subscribe";

      if (phone && phone.value === "") {
        messages.textContent = "Please enter a valid phone number";
        messages.classList.remove("hidden"); 
        return false;
      }

      const countryCode = document.querySelector('.iti__selected-flag').getAttribute('title').split(': ')[1];
      const phoneNumber = `${countryCode}${phone.value}`;

      const bodyContent = {
        g: listId,
        sms_consent: true,
        $fields: '$phone_number,sms_consent',
        $phone_number: phoneNumber,
        $consent: ['sms']
      };

      fetch(subscribeUrl, {
        body: new URLSearchParams(bodyContent),
        method: "POST"
      })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        
        if (response.success) {
          messages.textContent = successMessage;
          
          if (window.location.href.indexOf('/pages/signup-new') > -1) {
            const redirectTo = '/collections/best-sellers?filter.v.availability=1';
        
            setTimeout(function() {
              window.location.href = redirectTo;
            }, 4000);
          }
        } else {
          messages.textContent = response.errors;
        }
        
        messages.classList.remove("hidden");
      })
      .catch((err) => {
        console.error(err);
      });

      return true;
    });
  });
})();

